const messages = {
  en: {
    message: {
      appTitle: 'Make a damaged luggage claim',
      headerLogoAlt: 'easyJet',
      headerEmailIconAlt: 'Email us',
      backButton: 'Back',
      nextButton: 'Proceed',
      deleteButton: 'Delete',
      cancelButton: 'Cancel',
      yesButton: 'Yes',
      noButton: 'No',
      backToStart: 'Back to start',
      chatTitle: 'Live Chat',
      chatSubTitle: 'Mon - Fri 9am – 5pm',
      datePlaceholderText: 'Select date',
      selectPlaceholderText: 'Select',
      formErrorTitle: 'Form error',
      formErrorMessage: 'Please fix any form errors to continue',
      gdpr: {
        nextButtonText: 'Proceed with claim'
      },
      claimType: {
        title: 'How can we help?'
      },
      dataPreparation: {
        completeFormSentence: 'Please ensure you have filled out a customs form and post it in the box to your right.',
        airportDeliverySentence: 'Without a completed customs declaration we will not be able to remove your luggage from the airport to arrange delivery.',
        pleaseContinue: 'Once completed, please click proceed to continue.',
      },
      boardingPassScan: {
        scanToGetStarted: 'Scan your boarding pass to get started',
        pleaseScanDescriptionText: 'Please scan the barcode or QR code from your boarding pass to beging the claim process.',
        noBoardingPass: 'No boarding pass?',
        enterFlightDetailsManually: 'Enter flight details manually'
      },
      boardingPassConfirm: {
        weFoundFollowingDetails: 'We found the following details',
        name: 'Name',
        flightNumber: 'Flight number',
        dateOfFlight: 'Date of flight',
        departureAirport: 'Departure airport',
        arrivalAirport: 'Arrival airport',
        areAboveDetailsCorrect: 'Are the above details correct?',
        yesProceedButton: 'Yes, proceed',
        noScanAgainButton: 'No, scan again',
        enterFlightDetailsManually: 'Enter flight details manually'
      },
      about: {
        title: 'About You',
        firstName: 'Name',
        surname: 'Surname',
        emailAddress: 'Email',
        phoneNumber: 'Telephone',
        phoneNumber2: 'Telephone 2',
        country: 'Country',
        fiscalCode: 'Fiscal code',
        address: 'Address',
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2',
        addressLine3: 'Address Line 3',
        nameOnDoorBuzzer: 'Name on door buzzer',
        city: 'City',
        county: 'County',
        postcode: 'Postcode',
        selectAddressPlaceholderText: 'Select address',
        searchDifferentAddress: 'Search for a different address',
        manualAddress: 'Enter address manually',
        editAddress: 'Edit address'
      },
      address: {
        homeAddressTitle: 'Home address',
        tempAddressTitle: 'Visiting address',
        differentAddress: 'Are you currently visiting a temporary address?',
        dateTempAddress: 'Last date at temporary address',
        plannedTravel: 'Are you planning to travel soon?',
        plannedTravelDate: 'When are you planning to travel?'
      },
      flightDetails: {
        title: 'Flight details',
        bookingRef: 'Booking Ref',
        flightRef: 'Flight No',
        flightDate: 'Date of flight',
        findAFlightButton: 'Find a flight',
        findClaimButton: 'Find claim details',
        incidentLabel: 'Was the incident reported at the airport?',
        pirRefLabel: 'PIR number (report reference number)',
        pirRef: 'PIR',
        dateReported: 'Date reported',
        flightFinderInProgress: 'Finding flight...',
        flightClaimInProgress: 'Finding claim...',
        findClaimErrorHeading: 'We couldn\'t find your claim details',
        findClaimErrorMessage: 'Please check the above details and try again. If you can\'t find your claim details, you can still manually submit the form below',
        findClaimSuccessHeading: 'We successfully located your details from your PIR',
        findClaimSuccessMessage: 'Please continue to submit your claim below',
        flightFinderSuccessHeading: 'Outbound',
        flightFinderSuccessMessageJoiner: 'to',
        flightFinderErrorIconAlt: 'Error',
        flightFinderErrorHeading: 'We couldn\'t find your flight',
        flightFinderErrorMessage: 'Please check the above details and try again. If you can\'t find your flight, you can still submit these details, but this may result in a slower claim turnaround time',
        flightFinderErrorCheckboxLabel: 'Submit my claim using the above details',
        clearFlightFinderIconAlt: 'Clear',
        clearFlightFinderMessage: 'Clear and find another flight',
        arrivalAirport: 'Arrival airport',
        departureAirport: 'Departure airport',
        workOrderNumber: '',
        bookingRefIconAlt: 'Booking reference or work order number',
        bookingRefInfoHeader: 'Booking reference or work order number',
        bookingRefInfoParagraph: 'Some airlines may give you a work order number instead of a booking reference.'
      },
      addClaimsItem: {
        title: 'Add a damaged item',
        itemTypeLabel: 'Claim Type',
        baggageButton: 'Baggage',
        contentsButton: 'Contents',
        addToClaimButton: 'Add to claim',
        saveToClaimButton: 'Save'
      },
      replacementItem: {
        title: 'Replacement',
        notRepairable: 'It looks like the damage isn’t repairable.',
        chooseReplacement: 'Please choose a replacement:',
        noReplacementText: 'No replacement - request to speak to an agent instead. This may result in a slower claim turnaround time.',
        noReplacementOptions: 'Unfortunately, no replacement options were found for this baggage item. A replacement or repair for your baggage item will be considered by an agent at a later stage.',
        chooseReplacementColour: 'Please choose your preferred colour?',
        chooseReplacementAltColour: 'Please select any other colours you would accept?',
        disclaimerHeader: 'Disclaimer',
        additionalInfo: 'If you would like to provide us with more details, there is a comments box on the next page.',
        disclaimerText: 'This is a representation of the luggage you will receive. Although all the features you see will be offered there may be some changes in look and design.',
        advisoryText: 'Please be advised the replacement you have selected may be subject to change should our experienced team feel there is a replacement better suited to your damaged item.'
      },
      baggageItem: {
        type: 'Type',
        tagNumber: 'Baggage Tag No',
        brand: 'Brand Name',
        colour: 'Colour',
        dimensionsIllustration: 'Please measure your bag from the bottom to the top (including wheels).',
        dimensionsInfoIconAlt: 'Dimensions info',
        dimensionsBaggageIconAlt: 'Baggage dimensions diagram',
        height: 'Height (cm)',
        length: 'Length (cm)',
        material: 'Construction',
        proofOfDamagesTitle: 'Proof of damages',
        costTitle: 'Original Cost',
        datePurchased: 'Date of purchase',
        receiptNote: 'Adding a receipt helps to process your claim faster.',
        receiptButton: 'Upload Receipt',
        wheels: 'Wheels',
        locks: 'Locks',
        morePhotos: 'Add more photos',
        wholeCaseUpload: 'Photo showing the whole case or bag',
        wholeCaseUploadBuggyType: 'Photo showing the whole item',
        badgeUpload: 'Photo showing the case’s or bag’s badge',
        badgeUploadBuggyType: 'Photo showing the item’s badge',
        baggageTagUpload: 'Photo showing the baggage tag',
        areaOfDamageUpload: {
          caption: 'A photo of each area of damage',
          selectPlaceholder: 'Select damage',
          selectOptions: {
            top: 'Top',
            bottom: 'Bottom',
            left: 'Left',
            right: 'Right'
          }
        },
        price: 'Price',
        isExpandable: 'Is the item expandable?',
        damageType: 'Damage type',
        model: 'Model',
        serialNumber: 'Serial Number'
      },
      contentsItem: {
        name: 'Damaged item',
        damageDesc: 'Damage occurred',
        proofOfDamagesTitle: 'Proof of damages',
        costTitle: 'Original Cost',
        datePurchased: 'Date of purchase',
        receiptNote: 'Adding a receipt helps to process your claim faster.',
        receiptButton: 'Upload Receipt',
        morePhotos: 'Add more photos',
        wholeItemUpload: 'Photo showing the whole damaged item',
        areaOfDamageUpload: {
          caption: 'A photo of each area of damage',
          selectPlaceholder: 'Select damage',
          selectOptions: {
            top: 'Top',
            bottom: 'Bottom',
            left: 'Left',
            right: 'Right'
          }
        }
      },
      claimsItemsSummary: {
        title: 'Existing Items',
        deleteItemTitle: 'Confirm item delete',
        deleteConfirmationMessage: 'Are you sure you\'d like to delete',
        addButton: 'Add another'
      },
      claimsItem: {
        photo: 'photo',
        photos: 'photos',
        receipt: 'receipt added',
        receipts: 'receipts added',
        deleteItem: 'Delete item',
        editItem: 'Edit item'
      },
      submitClaim: {
        title: 'Submit claim',
        additionalInfo: 'Additional info',
        additionalInfoPlaceholder: 'Please inform us of any additional information about this claim you would like us to consider',
        termsCheckboxLabelPrefix: 'I agree to the',
        termsCheckboxLabel: 'terms and conditions',
        infoConfirmationCheckboxLabel: 'I confirm all the information I have provided is correct.',
        submitClaimButton: 'Submit claim',
        submitClaimError: 'Submission error. Please try again.',
        whatsNextTitle: 'What’s next?',
        keepLuggageLabelPrefix: 'Please ensure you' ,
        keepLuggageLabel: 'do not throw away your damaged luggage',
        keepLuggageLabelSuffix: 'as we will require you to provide photographic evidence.',
        waitForConfirmationLabel: 'Once you have submitted your claim our team will be in touch to confirm the next steps and any evidence required.',
        infoIconAlt: 'Exclamation mark info',
        requiredBaggageIconAlt: 'Baggage photos required',
      },
      submitSuccess: {
        title: 'Claim submitted',
        header: 'Thank you for submitting a claim',
        text: 'Your claim application is now being processed.',
        refNumber: 'Your reference number is',
        emailSoon: 'You will receive an email soon confirming the next step.',
        buttonText: 'Back to home',
        pageWillCloseTitle: 'This page will automatically close in',
        pageWillCloseSeconds: 'seconds'
      },
      makeDelayedClaim: {
        title: 'Make a delayed luggage claim',
        header: 'Please scan the QR code below and fill in the form.',
        buttonText: 'Back to start',
      },
      claimStatus: {
        title: 'Claim status',
        statusPageTitle: 'Your claim summary',
        messagesPageTitle: 'Your claim messages',
        claimUpdateItemTitle: 'Add required images',
        summaryHeader: 'Claim summary',
        help: 'For assistance, please reply or contact us on www.damagedluggage.com using Live Chat',
        phoneIconAlt: 'Help',
        missingDataIconAlt: 'Error',
        missingDataHeading: 'Please complete missing information',
        missingDataMessage: 'We require some more information in order to process your claim for the following items:',
        updateClaimButton: 'Update claim',
        errorHeader: 'Loading error',
        errorMessage: 'An error occurred while trying to load your claim status. Please try again.',
        claimRef: 'Claim reference',
        claimMade: 'Date claim made',
        flightDate: 'Flight date',
        baggageItems: 'Baggage items',
        itemNoMissingData: 'This item, has no missing data.',
        replacementItemsRequiresConfirmation: 'Confirm replacement items',
        replacementItemsRequiresConfirmationMessage: 'Please confirm replacement items.',
        claimStatusUpdate: 'Claim status update',
        replacementItemsConfirmation: {
          title: 'Replacement items',
          singleItemReplacement: 'Please review the following replacement',
          multipleItemReplacement: 'Please review the following replacements',
          confirmText: 'Confirm the offer.',
          declineText: 'Decline the offer. Talk to an agent instead.',
          declineModalTitle: 'Decline',
          declineModalText: 'Would you like to give a reason?',
          declineModalWarning: 'Declining this replacement may result in a slower claim turnaround time.',
          confirmButtonText: 'Confirm',
          declineButtonText: 'Decline'
        },
        actionRequiredTitle: 'Action required',
        actionRequiredText: 'We require some more information in order to process your claim further.',
        titleMessages: 'Latest message',
        viewMessages: 'Messages',
        newMessage: 'Reply',
        noMessages: 'No messages have been added to your claim. Check back soon.',
        messageClientPrefix: 'Me',
        messageAdminPrefix: 'Damaged Luggage team',
        newMessageModalTitle: 'New message',
        newMessageModalSendButton: 'Send',
        titleDocuments: 'Upload a document',
        sendDocument: 'Send document'
      },
      postcodeLookup: {
        errorMessages: {
          invalid: 'Invalid address or postcode format - Please try again',
          notFound: 'Cannot find address - Please try again'
        },
        defaults: {
          buttonText: 'Find address',
          placeholder: 'Address or postcode'
        }
      },
      verification: {
        pageTitle: 'Verification',
        verificationCode: 'Verification code',
        sendNewVerificationCode: 'Email me a verification code',
        newCodeSuccess: 'Please check your email.',
        newCodeFailed: 'Error, Please try again.'
      },
      screensaver: {
        title: 'Report delayed or damaged luggage.',
        selectLanguage: 'Select language',
        getStarted: 'Get started'
      },
      imageUpload: {
        preparing: 'Preparing image…',
        tryAgain: 'Try again',
        errors: {
          unsupportedType: 'That file type isn\'t supported. Please choose a photo.',
          heicFailed: 'We couldn\'t read this photo. Try retaking it or choose a different one.',
          tooLarge: 'This image is too large even after compression — please try a different photo.',
          unauthorized: 'We couldn\'t save this image. Please refresh the page and try again.',
          unknown: 'Upload failed. Check your connection and try again.'
        }
      },
      apiTranslations: {
        'An invalid code has been entered too many times.\\nPlease request a new code and try again.': 'An invalid code has been entered too many times.\\nPlease request a new code and try again.',
        'Buggy': 'Buggy',
        'Claim not found.\\nPlease contact support for help.': 'Claim not found.\\nPlease contact support for help.',
        'Golf Travel Bag': 'Golf Travel Bag',
        'Hard Shell Golf Case': 'Hard Shell Golf Case',
        'Hard Shell Traditional Style Case' : 'Hard Shell Traditional Style Case ',
        'Hard Shell Trolley Suitcase': 'Hard Shell Trolley Suitcase',
        'Holdall': 'Holdall',
        'Missing claim identifier.\\nPlease contact support for help.': 'Missing claim identifier.\\nPlease contact support for help.',
        'Missing verification code.\\nPlease contact support for help.': 'Missing verification code.\\nPlease contact support for help.',
        'Our records show your claim to now be resolved.  You can still get in touch with a message below if you need us.': 'Our records show your claim to now be resolved.  You can still get in touch with a message below if you need us.',
        'Please respond to the below message to progress your claim.': 'Please respond to the below message to progress your claim.',
        'RuckSack': 'RuckSack',
        'Soft Shell Trolley Suitcase': 'Soft Shell Trolley Suitcase',
        'This claim has been closed.\\nPlease contact support for help.': 'This claim has been closed.\\nPlease contact support for help.',
        'This code has now expired.\\nPlease request a new code and try again.': 'This code has now expired.\\nPlease request a new code and try again.',
        'This code is unrecognised.\\nPlease double check your code or request a new code and try again.': 'This code is unrecognised.\\nPlease double check your code or request a new code and try again.',
        'Your claim has been passed to our accounts team.  We aim to process payments within 14 working days where possible.': 'Your claim has been passed to our accounts team.  We aim to process payments within 14 working days where possible.',
        'Your claim has been rejected as your claim was submitted more than 7 days after the damage date.': 'Your claim has been rejected as your claim was submitted more than 7 days after the damage date.',
        'Your claim has been rejected.': 'Your claim has been rejected.',
        'Your claim is being handled by our warehouse team who are getting your item ready for despatch.': 'Your claim is being handled by our warehouse team who are getting your item ready for despatch.',
        'Your claim is being reviewed, we will be in touch when we have an update for you.': 'Your claim is being reviewed, we will be in touch when we have an update for you.',
        'Your item has been despatched.': 'Your item has been despatched.',
        'Your replacement bag is currently out of stock. There is no need for you to do anything at this time we will send your luggage as soon as it is in stock.': 'Your replacement bag is currently out of stock. There is no need for you to do anything at this time we will send your luggage as soon as it is in stock.'
      }
    }
  }
}
export default messages
